import { TRENDS } from './record'

// A composite 0–100 "health score" computed from the latest of each tracked metric vs its target.
// Illustrative for the demo, but derived from the same data SARA coaches on.
function clamp(n: number) {
  return Math.max(0, Math.min(100, n))
}

const SCORERS: Record<string, (v: number) => number> = {
  'Systolic BP': (v) => clamp(100 - (v - 115) * 3.2), // 115 ideal → falls off into stage-1/2
  Sleep: (v) => clamp((v / 7.5) * 100),
  'Glucose (avg)': (v) => clamp(100 - (v - 95) * 2.4),
  Steps: (v) => clamp((v / 8000) * 100),
  HRV: (v) => clamp((v / 62) * 100),
}

export function healthScore(): { score: number; label: string; tone: 'success' | 'warning' | 'alert' } {
  const parts = TRENDS.map((t) => {
    const fn = SCORERS[t.metric]
    return fn ? fn(t.series[t.series.length - 1]) : null
  }).filter((n): n is number => n !== null)
  const score = Math.round(parts.reduce((a, b) => a + b, 0) / parts.length)
  if (score >= 80) return { score, label: 'Strong', tone: 'success' }
  if (score >= 60) return { score, label: 'Needs attention', tone: 'warning' }
  return { score, label: 'At risk', tone: 'alert' }
}
